import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const CategoryListing = () => {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${baseUrl}/catogray/categories`);
                const result = await response.json();
                if (!response.ok && !result.message?.data) {
                    throw new Error("Failed to fetch categories");
                }
                setCategories(result.message.data || []);
                setLoading(false);
            } catch (err) {
                setError("Failed to fetch categories");
                setLoading(false);
            }
        };

        fetchCategories();
    }, [baseUrl]);

    const counts = categories.map(() => Math.floor(Math.random() * 100) + 20);

    const data = {
        labels: categories.map(cat => cat.categoryTitle),
        datasets: [
            {
                label: "This Year",
                data: counts,
                backgroundColor: categories.map((_, i) =>
                    i % 2 === 0 ? "#27648B" : "#E6EEF5"
                ),
                borderRadius: 5,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 10,
                    callback: (value) => `${value}%`,
                },
            },
            x: {
                barPercentage: 0.5,
                categoryPercentage: 0.7,
            },
        },
    };

    if (loading) return <p>Loading category chart...</p>;
    if (error) return <p className="text-red-500">{error}</p>;

    return (
        <div className="w-[320px] h-[200px] mt-4 lg:mt-0  lg:h-[400px] lg:w-full p-5  bg-[#ffff] rounded-lg shadow-md">
            <div className="flex justify-between items-center mb-0">
                <h2 className="text-lg font-semibold text-[#252C58]">Category Listing</h2>
            </div>
            <div className="w-full h-[250px]  sm:h-[250px] md:h-[350px] lg:h-[400px] mt-10">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default CategoryListing;
